const defaultLocale = "it"

const UrlScheme = {
  it: {
    applications: "applicazioni",
    products: "prodotti",
    company: "azienda",
    search: "ricerca",
    contacts: "contatti",
    where: "dove-siamo",
    careers: "lavora-con-noi",
  },
  en: {
    applications: "applications",
    products: "products",
    company: "company",
    search: "search",
    contacts: "contacts",
    where: "where-we-are",
    careers: "careers",
  },
  fr: {
    applications: "applications",
    products: "products",
    company: "company",
    search: "search",
    contacts: "contacts",
    where: "where-we-are",
    careers: "careers",
  },
  de: {
    applications: "anwendungen",
    products: "produkte",
    company: "unternehmenienda",
    search: "suche",
    contacts: "fragen-sie-nach-informationen",
    where: "wo-wir-sind",
    careers: "karriere",
  },
}

export function getPagePath(page, locale) {
  if (!page || !page._allSlugLocales) {
    console.warn('getPagePath: page or page._allSlugLocales is null/undefined', page)
    return locale === defaultLocale ? "/" : `/${locale}/`
  }

  const pageLocale = locale || page.locale
  let lang = pageLocale === defaultLocale ? "/" : `/${pageLocale}/`
  let path = `${page._allSlugLocales.find(x => x.locale === pageLocale)?.value || ''}`
  if (page.root) {
    return lang + `${path}/`
  }

  if (!page.treeParent || !page.treeParent._allSlugLocales) {
    console.warn('getPagePath: page.treeParent or page.treeParent._allSlugLocales is null/undefined', page.treeParent)
    return lang + `${path}/`
  }

  path = `${page.treeParent._allSlugLocales.find(x => x.locale === pageLocale)?.value || ''
    }/${path}`
  if (page.treeParent.root) {
    return lang + `${path}/`
  }

  if (!page.treeParent.treeParent || !page.treeParent.treeParent._allSlugLocales) {
    console.warn('getPagePath: page.treeParent.treeParent or its _allSlugLocales is null/undefined', page.treeParent.treeParent)
    return lang + `${path}/`
  }

  path = `${page.treeParent.treeParent._allSlugLocales.find(
    x => x.locale === pageLocale
  )?.value || ''
    }/${path}`
  return lang + `${path}/`
}

export function getPagePathLegacy(page) {
  if (!page) {
    console.warn('getPagePathLegacy: page is null/undefined')
    return "/"
  }

  // console.log(page)
  let lang = page.locale === "it" ? "/" : `/${page.locale}/`
  let path = page.slug || ''
  if (page.root) {
    return lang + path
  }

  if (!page.treeParent) {
    console.warn('getPagePathLegacy: page.treeParent is null/undefined')
    return lang + path
  }

  path = `${page.treeParent.slug || ''}/${path}`
  if (page.treeParent.root) {
    return lang + path
  }

  if (!page.treeParent.treeParent) {
    console.warn('getPagePathLegacy: page.treeParent.treeParent is null/undefined')
    return lang + path
  }

  path = `${page.treeParent.treeParent.slug || ''}/${path}`
  return lang + path
}

export function getApplicationPath(page, locale) {
  console.log("PAGE", page, locale, !page || !page._allSlugLocales)
  if (!page || !page._allSlugLocales) {
    console.warn('getApplicationPath: page or page._allSlugLocales is null/undefined', page)
    const pageLocale = locale || defaultLocale
    return pageLocale === defaultLocale
      ? "/applicazioni/"
      : `/${pageLocale}/${UrlScheme[pageLocale]?.applications || 'applications'}/`
  }

  const pageLocale = locale || page.locale
  let lang =
    pageLocale === defaultLocale
      ? "/applicazioni/"
      : `/${pageLocale}/${UrlScheme[pageLocale]?.applications || 'applications'}/`
  let path = `${page._allSlugLocales.find(x => x.locale === pageLocale)?.value || ''}`
  return lang + `${path}/`
}

export function getArticlePath(page, locale) {
  if (!page || !page._allSlugLocales) {
    console.warn('getArticlePath: page or page._allSlugLocales is null/undefined', page)
    return locale === defaultLocale ? `/blog/` : `/${locale}/blog/`
  }

  return locale === defaultLocale
    ? `/blog/${page._allSlugLocales.find(x => x.locale === locale)?.value || ''}`
    : `/${locale.toLowerCase()}/blog/${page._allSlugLocales.find(x => x.locale === locale)?.value || ''
    }/`
}

export function getNewsArticlePath(page, locale) {
  if (!page || !page._allSlugLocales) {
    console.warn('getNewsArticlePath: page or page._allSlugLocales is null/undefined', page)
    return locale === defaultLocale ? `/news/` : `/${locale}/news/`
  }

  return locale === defaultLocale
    ? `/news/${page._allSlugLocales.find(x => x.locale === locale)?.value || ''}`
    : `/${locale.toLowerCase()}/news/${page._allSlugLocales.find(x => x.locale === locale)?.value || ''
    }/`
}

export function getNewsArticleNewPath(page, category, locale) {
  if (!page || !page._allSlugLocales) {
    console.warn('getNewsArticleNewPath: page or page._allSlugLocales is null/undefined', page)
    return locale === defaultLocale
      ? `/${category}/`
      : `/${locale.toLowerCase()}/${category}/`
  }

  return locale === defaultLocale
    ? `/${category}/${page._allSlugLocales.find(x => x.locale === locale)?.value || ''
    }/`
    : `/${locale.toLowerCase()}/${category}/${page._allSlugLocales.find(x => x.locale === locale)?.value || ''
    }/`
}

export function getProductPath(page, locale) {
  if (!page || !page._allSlugLocales) {
    console.warn('getProductPath: page or page._allSlugLocales is null/undefined', page)
    const pageLocale = locale || defaultLocale
    return pageLocale === defaultLocale
      ? `/${UrlScheme["it"].products}/`
      : `/${pageLocale}/${UrlScheme[pageLocale]?.products || 'products'}/`
  }

  const pageLocale = locale || page.locale
  let lang =
    pageLocale === defaultLocale
      ? `/${UrlScheme["it"].products}/`
      : `/${pageLocale}/${UrlScheme[pageLocale]?.products || 'products'}/`
  let path = `${page._allSlugLocales.find(x => x.locale === pageLocale)?.value || ''}`
  return lang + `${path}/`
}

export function getCategoryPath(page, locale) {
  if (!page || !page._allSlugLocales) {
    console.warn('getCategoryPath: page or page._allSlugLocales is null/undefined', page)
    const pageLocale = locale || defaultLocale
    return pageLocale === defaultLocale ? "/" : `/${pageLocale}/`
  }

  if (!page.application) {
    console.warn('getCategoryPath: page.application is null/undefined', page)
    const pageLocale = locale || page.locale
    return pageLocale === defaultLocale ? "/" : `/${pageLocale}/`
  }

  const pageLocale = locale || page.locale
  let root = getApplicationPath(page.application, pageLocale)
  let path = `${page._allSlugLocales.find(x => x.locale === pageLocale)?.value || ''}`
  return root + `${path}/`
}

export function getBlogPath(locale) {
  return locale === defaultLocale ? `/blog/` : `/${locale}/blog/`
}

export function getNewsPath(locale) {
  return locale === defaultLocale ? `/news/` : `/${locale}/news/`
}

export function getWherePath(locale) {
  return locale === defaultLocale
    ? `/${UrlScheme[locale].where}/`
    : `/${locale}/${UrlScheme[locale].where}/`
}

export function getHomePath(locale) {
  return locale === defaultLocale ? `/` : `/${locale}/`
}

export function getContactPath(locale) {
  return locale === defaultLocale
    ? `/contatti/`
    : `/${locale}/${UrlScheme[locale].contacts}/`
}

export function getCareersPath(locale) {
  return locale === defaultLocale
    ? `/${UrlScheme[locale].careers}/`
    : `/${locale}/${UrlScheme[locale].careers}/`
}

export function getSearchPath(locale) {
  return locale === defaultLocale
    ? `/${UrlScheme[locale].search}/`
    : `/${locale}/${UrlScheme[locale].search}/`
}

export function getRealApplication(node) {
  if (!node.application) return null

  if (
    node.application.model &&
    node.application.model.apiKey === "application_page"
  ) {
    return node.application
  }

  if (
    node.application.model &&
    node.application.model.apiKey === "category_page"
  ) {
    return getRealApplication(node.application)
  }

  if (node.application.__typename === "DatoCmsCategoryPage") {
    if (node.application.application) {
      return node.application.application
    }
  }

  return node.application
}

export function getMenuApplicationLink(application, locale) {
  if (!application || !application.model) return null

  switch (application.model.apiKey) {
    case "page":
      return { href: getPagePath(application, locale), external: false }
    case "link":
      return {
        href: application.url,
        external: true,
        newWindow: !!application.openInNewWindow,
      }
    case "category_page":
      return {
        href: getCategoryPath(
          { ...application, application: getRealApplication(application) },
          locale
        ),
        external: false,
      }
    case "product_page":
      return { href: getProductPath(application, locale), external: false }
    case "application_page":
      return { href: getApplicationPath(application, locale), external: false }
    default:
      return null
  }
}
